import { render, staticRenderFns } from "./pubLayout.vue?vue&type=template&id=56662ab5&"
import script from "./pubLayout.vue?vue&type=script&lang=js&"
export * from "./pubLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports